export interface Tag {
    id: string;
    type?: TagType;
    system?: boolean;
}

/**
 *  Didn't changed type of id in Tag since id can also be string
 */

export enum TagId {
    AFFILIATE = "Affiliate",
    AGENT = "Agent",
    WAITLIST = "Waitlist",
    AFFILIATE_OVERRIDE = "affiliate_override",
    ID_VERIFIED = "Identify Verified",
    ID_NOT_VERIFIED = "Identity Unverified",
}

export enum TagType {
    GIFT = "gift",
    COUPON_CODE = "coupon_code",
    MEMBERSHIP = "membership",
    STORE_CREDIT = "store_credit",
}
